import { API_ROUTES } from "../config";
import { http } from "../http";

export const getFeedsService = async (page = 1, limit = 10, view = null) => {
  try {
    const params = { page, limit };
    if (view) params.view = view;
    const response = await http().get(API_ROUTES.feeds, { params });
    return response.data;
  } catch (err) {
    console.error("Error fetching feeds:", err);
    throw err;
  }
};

export const getFeedByIdService = async (id) => {
  try {
    const response = await http().get(`${API_ROUTES.feeds}/${id}`);
    return response.data;
  } catch (err) {
    console.error(`Error fetching feed ${id}:`, err);
    throw err;
  }
};

export const likeFeedService = async (id) => {
  try {
    const response = await http().post(`${API_ROUTES.feeds}/${id}/like`);
    return response.data;
  } catch (err) {
    console.error(`Error liking feed ${id}:`, err);
    throw err;
  }
};

export const updateFeedService = async (id, data) => {
  try {
    const response = await http().put(`${API_ROUTES.feeds}/${id}`, data);
    return response.data;
  } catch (err) {
    console.error(`Error updating feed ${id}:`, err);
    throw err;
  }
};

export const deleteFeedService = async (id) => {
  try {
    const response = await http().delete(`${API_ROUTES.feeds}/${id}`);
    return response.data;
  } catch (err) {
    console.error(`Error deleting feed ${id}:`, err);
    throw err;
  }
};
